import { LabelClass } from "datamodel/labeClass";
import { LabelGroup } from "datamodel/labelGroup";

const collapse = (groups: LabelGroup[]) =>
  groups.reduce((acc, g) => [...acc, ...g.classes], [] as LabelClass[]);

export default collapse;
